// @core/api/endpoints/project/delete_project.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/project';

/**
 * Delete project
 * Deletes or archives a project. Archived projects can be restored; deleted projects are permanently removed along with all project-specific data.
 */
export async function DeleteProject(
  project_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
